/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetDetailIncidentAffectedComponentResponseDto } from './AssetDetailIncidentAffectedComponentResponseDto';
import {
    AssetDetailIncidentAffectedComponentResponseDtoFromJSON,
    AssetDetailIncidentAffectedComponentResponseDtoFromJSONTyped,
    AssetDetailIncidentAffectedComponentResponseDtoToJSON,
    AssetDetailIncidentAffectedComponentResponseDtoToJSONTyped,
} from './AssetDetailIncidentAffectedComponentResponseDto';

/**
 * 
 * @export
 * @interface AssetDetailIncidentResponseDto
 */
export interface AssetDetailIncidentResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetDetailIncidentResponseDto
     */
    id: string;
    /**
     * Human-readable incident code (e.g. INC-…)
     * @type {string}
     * @memberof AssetDetailIncidentResponseDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDetailIncidentResponseDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDetailIncidentResponseDto
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof AssetDetailIncidentResponseDto
     */
    severity: number | null;
    /**
     * 
     * @type {string}
     * @memberof AssetDetailIncidentResponseDto
     */
    description: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetDetailIncidentResponseDto
     */
    priority: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetDetailIncidentResponseDto
     */
    openedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetDetailIncidentResponseDto
     */
    resolvedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetDetailIncidentResponseDto
     */
    closedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetDetailIncidentResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Array<AssetDetailIncidentAffectedComponentResponseDto>}
     * @memberof AssetDetailIncidentResponseDto
     */
    affectedComponents: Array<AssetDetailIncidentAffectedComponentResponseDto>;
}

/**
 * Check if a given object implements the AssetDetailIncidentResponseDto interface.
 */
export function instanceOfAssetDetailIncidentResponseDto(value: object): value is AssetDetailIncidentResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('severity' in value) || value['severity'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('openedAt' in value) || value['openedAt'] === undefined) return false;
    if (!('resolvedAt' in value) || value['resolvedAt'] === undefined) return false;
    if (!('closedAt' in value) || value['closedAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('affectedComponents' in value) || value['affectedComponents'] === undefined) return false;
    return true;
}

export function AssetDetailIncidentResponseDtoFromJSON(json: any): AssetDetailIncidentResponseDto {
    return AssetDetailIncidentResponseDtoFromJSONTyped(json, false);
}

export function AssetDetailIncidentResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetDetailIncidentResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'title': json['title'],
        'status': json['status'],
        'severity': json['severity'],
        'description': json['description'],
        'priority': json['priority'],
        'openedAt': (json['openedAt'] == null ? null : new Date(json['openedAt'])),
        'resolvedAt': (json['resolvedAt'] == null ? null : new Date(json['resolvedAt'])),
        'closedAt': (json['closedAt'] == null ? null : new Date(json['closedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'affectedComponents': ((json['affectedComponents'] as Array<any>).map(AssetDetailIncidentAffectedComponentResponseDtoFromJSON)),
    };
}

export function AssetDetailIncidentResponseDtoToJSON(json: any): AssetDetailIncidentResponseDto {
    return AssetDetailIncidentResponseDtoToJSONTyped(json, false);
}

export function AssetDetailIncidentResponseDtoToJSONTyped(value?: AssetDetailIncidentResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'title': value['title'],
        'status': value['status'],
        'severity': value['severity'],
        'description': value['description'],
        'priority': value['priority'],
        'openedAt': value['openedAt'] == null ? value['openedAt'] : value['openedAt'].toISOString(),
        'resolvedAt': value['resolvedAt'] == null ? value['resolvedAt'] : value['resolvedAt'].toISOString(),
        'closedAt': value['closedAt'] == null ? value['closedAt'] : value['closedAt'].toISOString(),
        'createdAt': value['createdAt'].toISOString(),
        'affectedComponents': ((value['affectedComponents'] as Array<any>).map(AssetDetailIncidentAffectedComponentResponseDtoToJSON)),
    };
}

